const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const VisitorInformationSchema = (data) => {
    const schema = Joi.array().items(
        Joi.object({
            visitorName: Joi.string()
                .trim()
                .required()
                .messages({
                    "string.empty": currentLang?.ValidationSchema?.Name_Required,
                    "any.required": currentLang?.ValidationSchema?.Name_Required,
                }),
            dob: Joi.string()
                .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/)
                .required()
                .messages({
                    "string.pattern.base": currentLang?.ValidationSchema?.DOB_Format,
                    "string.empty": currentLang?.ValidationSchema?.DOB_Required,
                    "any.required": currentLang?.ValidationSchema?.DOB_Required,
                }),
            relation: Joi.string()
                .trim()
                .required()
                .messages({
                    "string.empty": currentLang?.ValidationSchema?.Relationship_required,
                    "any.required": currentLang?.ValidationSchema?.Relationship_required,
                }),
            phoneNo: Joi.string()
                .pattern(/^\d{10}$/)
                .required()
                .messages({
                    "string.pattern.base": currentLang?.ValidationSchema?.PhoneNumber_10_Digit,
                    "string.empty": currentLang?.ValidationSchema?.Phone_Required,
                    "any.required": currentLang?.ValidationSchema?.Phone_Required,
                }),
            streetName: Joi.string()
                .trim()
                .required()
                .messages({
                    "any.required": currentLang?.ValidationSchema?.Address_Required,
                    "string.empty": currentLang?.ValidationSchema?.Address_Required,
                }),
            city: Joi.string()
                .trim()
                .required()
                .messages({
                    "string.empty": currentLang?.ValidationSchema?.City_Required,
                    "any.required": currentLang?.ValidationSchema?.City_Required,
                }),
            stateNameID: Joi.number()
                .required()
                .messages({
                    "any.required": currentLang?.ValidationSchema?.State_Required,
                    "number.base": currentLang?.ValidationSchema?.State_Required,
                }),
            zip: Joi.string()
                .pattern(/^\d{5}$/)
                .required()
                .messages({
                    "string.pattern.base": currentLang?.ValidationSchema?.Zip_5_Digit,
                    "string.empty": currentLang?.ValidationSchema?.Zip_Required,
                    "any.required": currentLang?.ValidationSchema?.Zip_Required,
                }),
            visitorOrderNo: Joi.number()
                .required()
                .messages({
                    "any.required": currentLang?.ValidationSchema?.Visitor_Order_Required,
                    "number.base": currentLang?.ValidationSchema?.Visitor_Order_Valid,
                }),
        }).unknown(true)
    );

    return schema.validate(data, {
        abortEarly: false, // Do not stop after the first error
    });
};

module.exports = VisitorInformationSchema;
